export default __webpack_public_path__ + "static/media/up-square.c9b3e11a.svg";